module.exports = __webpack_public_path__ + "img/type12.5dd2fcf4.png";